import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e0d9a69"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "notion-toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  class: "notion-toolbar-inner",
  id: "kt_toolbar_container"
}
const _hoisted_3 = { class: "notion-toolbar-title" }
const _hoisted_4 = {
  key: 0,
  class: "notion-breadcrumbs"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-breadcrumb-sep" }, "/", -1))
const _hoisted_6 = { class: "notion-breadcrumb-text" }
const _hoisted_7 = {
  key: 1,
  class: "notion-page-heading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "notion-breadcrumb-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item), 1)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}